import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import VueMask from 'v-mask';
import { VueMaskDirective } from 'v-mask';
import PrimeVue from 'primevue/config';
import VueLazyload from 'vue-lazyload';
import VueExpandableImage from 'vue-expandable-image';
import VUppercase from 'v-uppercase';
import money from 'v-money';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import { RecycleScroller } from 'vue-virtual-scroller';
import VueObserveVisibility from 'vue-observe-visibility'

Vue.use(VueObserveVisibility)
Vue.component('RecycleScroller', RecycleScroller);

Vue.use(VueExpandableImage);

Vue.config.productionTip = false;
Vue.directive('mask', VueMaskDirective);
Vue.use(VueMask, {
  placeholders: {
    B: /[0-9 ,]/
  }
});
Vue.use(VUppercase);
Vue.use(PrimeVue);
Vue.use(VueLazyload);
Vue.use(money, { precision: 4 });

var filter = function (text, length, clamp) {
  clamp = clamp || '...';
  var node = document.createElement('div');
  node.innerHTML = text;
  var content = node.textContent;
  return content.length > length ? content.slice(0, length) + clamp : content;
};

Vue.filter('truncate', filter);

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App)
}).$mount('#app');
